import React, { Component } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import { ErrorMessage, Field, getIn } from 'formik';
export default class PhoneNumberField extends Component {
  state = {
    phoneNumberError: '',
  };

  validate = (value) => {
    const { field, isConstructorForm } = this.props;
    const { required } = field;
    let error;
    if (!isConstructorForm && required && !value) {
      error = 'This field is required';
    }
    if (this.state.phoneNumberError) {
      error = 'Invalid Number';
    }
    return error;
  };

  onPhoneNumberChange = (isValid, newNumber, countryData, fullNumber, isExtension) => {
    this.props.setFieldValue(this.props.field.fieldName, fullNumber);
    if (!isValid && fullNumber) {
      this.setState({ phoneNumberError: 'Invalid Number' });
    } else {
      this.setState({ phoneNumberError: '' });
    }
  };

  render() {
    const { field, values, isConstructorForm } = this.props;
    const phoneNumberValue = getIn(values, field.fieldName);
    let {
      extraFieldSetting: { allowedCountries, defaultCountry },
    } = field;
    defaultCountry = defaultCountry || 'us';
    return (
      <>
        <Field
          as={IntlTelInput}
          name={field.fieldName}
          containerClassName="intl-tel-input"
          inputClassName="form-control form-control-sm"
          onPhoneNumberChange={(...args) => this.onPhoneNumberChange(...args)}
          value={phoneNumberValue}
          placeholder={field.placeholder['en']}
          title={field.fieldTitle['en']}
          defaultCountry={defaultCountry}
          onlyCountries={allowedCountries}
        />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}
